import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer'
import '@cyntler/react-doc-viewer/dist/index.css'
import './DocViewerBlock.css'

export default function DocViewerBlock({ docUrl, className }: Readonly<{ docUrl: string; className: string }>) {
   const regex = /\.([a-zA-Z0-9]+)\?/
   const match = regex.exec(docUrl)
   const fileType = match ? match[1] : null

   const docs = [
      {
         uri: docUrl,
         fileType: fileType!,
      },
   ]
   return (
      <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
         <DocViewer
            className="doc-viewer-full"
            prefetchMethod="GET"
            documents={docs}
            pluginRenderers={DocViewerRenderers}
            config={{
               header: {
                  disableHeader: true,
               },
            }}
            initialActiveDocument={docs[0]}
         />
      </div>
   )
}
